import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-agenda-tipo',
  templateUrl: './agenda-tipo.component.html',
  styleUrls: ['../../../assets/css/styles.css', './agenda-tipo.component.css']
})
export class AgendaTipoComponent implements OnInit {
  
  idDoctor: string = '';
  item: string = '';

  constructor(private route: ActivatedRoute, private router: Router) {}

  ngOnInit(): void {
    // Obtener los parámetros de la URL
    this.route.params.subscribe(params => {
      this.idDoctor = params['id_doctor'];
      this.item = params['item'];
    });
  }

  // Redirige a la agenda con el tipo 'reserva'
  configuracionReserva() {
    this.router.navigate([`agenda/${this.idDoctor}/${this.item}/reserva`]);
  }

  // Redirige a la agenda con el tipo 'ondemand'
  configuracionOnDemand() {
    this.router.navigate([`agenda/${this.idDoctor}/${this.item}/ondemand`]);
  }
}
